<template>
  <div>

    <b-container fluid>
      <b-container class="padding" style="padding-bottom: 64px">
        <b-row align-v="center" align-h="center">
          <b-col cols="12" md="6">
            <h3>Pra que servem os rins</h3>
            <p>
              O equilíbrio da química interna de nossos corpos se deve em grande parte ao trabalho dos rins. Nossa sobrevivência depende do funcionamento normal destes órgãos vitais.
              <br />Os rins são responsáveis por quatro funções no organismo:
            </p>
            <ul class="list-item">
              <li>Eliminação de toxinas do sangue por um sistema de filtração;</li>
              <li>Regulação da formação do sangue e dos ossos;</li>
              <li>Regulação da pressão sanguínea;</li>
              <li>Controle do delicado balanço químico e de líquidos do corpo.</li>
            </ul>

            <hr />

            <h3>Conhecendo um pouco mais</h3>
            <p>
              Cada rim tem a forma de um grande grão de feijão, medindo em um adulto de 10 a 13 cm, com peso aproximado de 120 a 180g.
              <br />Os rins estão envolvidos por uma fina membrana, a chamada cápsula renal. Ao redor deles existe a gordura perirrenal e, acima, estão localizadas as glândulas suprarrenais.
              <br />No hilo renal entram e saem uma série de estruturas: a artéria renal, a veia renal, o ureter, os nervos renais e os vasos linfáticos renais.
              <br />O sangue chega aos rins através das artérias renais. As artérias renais originam-se na artéria aorta abdominal. Após circular pelos rins, o sangue retorna à veia cava abdominal através das veias renais.
              <br />Os rins recebem cerca de 1,2 litros de sangue por minuto, ou seja, cerca de um quarto do sangue bombeado pelo coração. Podemos dizer que os rins filtram todo o sangue de uma pessoa cerca de 12 vezes por hora!
            </p>
          </b-col>
          <b-col cols="12" md="6">
            <img src="@/assets/modulo01/rim.png" width="100%" alt="rim" />

            <b-row align-h="end" style="padding-top: 30px">
              <b-col cols="12" md="6">
                <ol class="list-img">
                  <li>Pirâmide Renal</li>
                  <li>Vaso Eferente</li>
                  <li>Artéria Renal</li>
                  <li>Veia Renal</li>
                  <li>Hilo Renal</li>
                  <li>Pelves Renal</li>
                  <li>Ureter</li>
                  <li>Cálice Renal Menor</li>
                  <li>Cápsula Renal</li>
                  <li>Cápsula Renal Inferior</li>
                </ol>
              </b-col>

              <b-col cols="12" md="6">
                <ol start="11" class="list-img">
                  <li>Cápsula Renal Superior</li>
                  <li>Vaso Aferente</li>
                  <li>Néfron</li>
                  <li>Cálice Renal Menor</li>
                  <li>Cálice Renal Maior</li>
                  <li>Papila Renal</li>
                  <li>Coluna Renal</li>
                </ol>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

    <b-container>
      <b-row align-h="center" class="text-center">
        <b-col sm="12" md="3">
          <router-link to="/rim-normal/" class="pagination-link" disabled>ANTERIOR</router-link>
          <router-link to="/rim-normal/revisao" class="pagination-link">PRÓXIMO</router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Intro"
};
</script>

<style scoped>
.list-item {
  list-style-type: square;
  list-style-position: inside;
  text-align: justify;
}
.list-img {
  list-style-type: decimal-leading-zero !important;
  list-style-position: outside !important;
}
.pagination {
  margin: 0;
}
.pagination-link {
  margin-right: 15px;
}
</style>